import { render, staticRenderFns } from "./TabsReport.vue?vue&type=template&id=2e9874cf&"
import script from "./TabsReport.vue?vue&type=script&lang=ts&"
export * from "./TabsReport.vue?vue&type=script&lang=ts&"
import style0 from "./TabsReport.vue?vue&type=style&index=0&id=2e9874cf&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports